import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * shadcn radix-nova Textarea primitive.
 *
 * Mirrors the Input class-chain with two field-specific tweaks:
 *   - `field-sizing-content` lets the browser grow the textarea to fit its
 *     own content (used by shadcn in radix-nova for free vertical resize).
 *   - `min-h-16` enforces a comfortable minimum height before content.
 *
 * Carries `peer` so Label's `peer-disabled:` flow lights up automatically.
 */
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentPropsWithoutRef<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-lg border border-input bg-transparent px-3 py-2 text-base transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 peer",
        className,
      )}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
